"use strict";

jQuery(document).ready(function ($) {
  // Make radio button text clickable
  $(".gfield_radio .gchoice, .gfield_checkbox .gchoice").on("click", function () {
    var targetID = "#" + $("label", this).attr("for");
    $(targetID).prop("checked", true);
  });
});